var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramControl64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Control64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(8.000000, 8.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1421476,41.6583652 L20.1421476,34.8518535 C20.1421476,30.4359742 16.5620917,26.8561968 12.1464909,26.8561968 L5.33997912,26.8561968 C6.71868066,34.3619727 12.6363717,40.2796637 20.1421476,41.6583652 Z M6.29422075,16.785123 L40.7041236,16.785123 C38.0182719,9.9076591 31.3276946,5.03553689 23.4991722,5.03553689 C15.6706497,5.03553689 8.98007242,9.9076591 6.29422075,16.785123 Z M41.6583652,26.8561968 L34.8524884,26.8561968 C30.4362585,26.8561968 26.8561968,30.4362526 26.8561968,34.8518535 L26.8561968,41.6583652 C34.3619727,40.2796637 40.2796637,34.3619727 41.6583652,26.8561968 Z M23.4991722,46.9983443 C10.5209377,46.9983443 0,36.4774066 0,23.4991722 C0,10.5209377 10.5209377,0 23.4991722,0 C36.4774066,0 46.9983443,10.5209377 46.9983443,23.4991722 C46.9983443,36.4774066 36.4774066,46.9983443 23.4991722,46.9983443 Z",
    id: "Wheel",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Focus",
    fill: "#FFCC00",
    cx: 23.4991722,
    cy: 23.4991722,
    r: 4.19628074
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramControl64);
export default __webpack_public_path__ + "static/media/pictogramControl64.2d97efc3a6d480865b00c76753f6fa3f.svg";
export { ForwardRef as ReactComponent };